/**
 * Created by chenchen on 2015/9/19.
 */
/*组件组合模块*/
"use strict";
angular.module('pieceMgr.widgetMgr', ["pieceMgr.widgetMgrdir"]).controller('PieceMgrTestController', ["$scope", "$http", "$q", "$compile", "$element",
    function($scope, $http, $q, $compile, $element) {
    }
]);

